import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useSystemDetailsTabs } from 'src/Libs/service-dashboard/hooks/use-system-details-tabs'
import FullBridgeConverter from './FullBridgeConverter'
import Powermeters from './Powermeters'
import Batteries from './Batteries'
import BatteryPowerManagement from './BatteryPowerManagement'
import PvInverters from './PvInverters'
import SystemDecommissionedBanner from '../decomission-banner/SystemDecommissionedBanner'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'

/**
 * Wrapper component that holds information about hardware components
 */
const HardwareComponents: React.FC = () => {
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()

  const { setActiveTab } = useSystemDetailsTabs(installationId, storageId)
  const { storageDeviceLink } = useActiveInstallationContext()

  useEffect(() => {
    setActiveTab(1)
  }, []) //eslint-disable-line

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <BannerQueue location={BannerLocations.SystemDetails} />
      <SystemDecommissionedBanner storage={storageDeviceLink} installationId={installationId!} />
      <FullBridgeConverter storageId={storageId} />
      <Powermeters storageId={storageId} />
      <Batteries />
      <BatteryPowerManagement storageId={storageId} />
      <PvInverters storageId={storageId} />
    </Box>
  )
}

export default HardwareComponents
